import request from "./../utils/request";

export function getFilters(key) {
    return request.get(`/fav-filters/${key}`).then((res) => res.data);
}

export function createFilter(key, name, filters, user, payload, icon, visibility, position, description) {
    console.log("createFilter", {
        key,
        name,
        filters,
        user,
        payload,
        icon,
        visibility,
        position,
        description,
    });
    return request
        .post(`/fav-filters`, {
            name,
            key,
            icon,
            visibility,
            position,
            filters,
            user,
            payload,
            description: description || "",
        })
        .then((res) => res.data);
}

export function updateFilter(id, icon, name, filters, visibility, description) {
    const body = {
        icon,
        name,
        filters,
        visibility,
    };
    if (description !== undefined) {
        body.description = description;
    }
    return request.patch(`/fav-filters/${id}`, body);
}

export function updateFilterMultipleKey(id, updatingFields) {
    return request.patch(`/fav-filters/${id}/multiple`, { updatingFields }).then((res) => res.data);
}

export function deleteFilter(id) {
    return request.delete(`/fav-filters/${id}`);
}
